import type { Theme } from '@emotion/react';

export enum BlogCategory {
  RELEASES = 'Releases',
  PRODUCT_UPDATES = 'Product Updates',
  GUIDES = 'Guides',
  NEWS = 'News',
  INSIGHTS = 'Insights'
}

export const BLOG_POST_CATEGORIES = [
  BlogCategory.RELEASES,
  BlogCategory.PRODUCT_UPDATES,
  BlogCategory.GUIDES,
  BlogCategory.NEWS,
  BlogCategory.INSIGHTS
] as const;

export const BLOG_CATEGORY_TONES: Record<BlogCategory, keyof Theme['selectionPill']['tones']> = {
  [BlogCategory.RELEASES]: 'cloudService',
  [BlogCategory.PRODUCT_UPDATES]: 'feature',
  [BlogCategory.GUIDES]: 'tool',
  [BlogCategory.NEWS]: 'interface',
  [BlogCategory.INSIGHTS]: 'insights'
};
